module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_m_albino.6ef853aa.png";